export class DeviceMake {
  Id: string;
  Name: string;

  constructor(id: string, name: string) {
    this.Id = id;
    this.Name = name;
  }
  }
  
  export class DeviceModel {
    Id: string;
    Key: string;
    Name: string;
    Value: string;
    SkuNumber: string;
    TypeCode:string;

    constructor(id: string, name: string, value: string, skuNumber: string,typeCode:string) {
      this.Id = id;
      this.Name = name;
      this.Value = value;
      this.SkuNumber = skuNumber;
      this.Key = name;
      this.TypeCode=typeCode;
    }
  }
  
  export class DeviceProtectionPlan {
    Id: string;
    Title: string;
    Description: string;
    MonhtlyPremium: Number; 
    UniqueId: string;
  }
